import { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { supabase } from '../lib/supabase'

export default function ResetPassword() {
  const navigate = useNavigate()
  const [password, setPassword] = useState('')
  const [confirm, setConfirm] = useState('')
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState('')
  const [done, setDone] = useState(false)

  useEffect(() => {
    // Supabase puts the token in the URL hash — it auto-handles the session
    const { data: { subscription } } = supabase.auth.onAuthStateChange((event) => {
      if (event === 'PASSWORD_RECOVERY') {
        // session is ready, user can now set new password
      }
    })
    return () => subscription.unsubscribe()
  }, [])

  async function handleSubmit() {
    if (!password || !confirm) { setError('Please fill in both fields.'); return }
    if (password !== confirm) { setError('Passwords do not match.'); return }
    if (password.length < 6) { setError('Password must be at least 6 characters.'); return }
    setLoading(true); setError('')
    const { error } = await supabase.auth.updateUser({ password })
    setLoading(false)
    if (error) setError(error.message)
    else setDone(true)
  }

  return (
    <div style={s.page}>
      <div style={s.card}>
        <div style={s.anchorWrap}>
          <svg width="32" height="32" viewBox="0 0 32 32" fill="none">
            <circle cx="16" cy="16" r="15" stroke="rgba(184,150,62,0.6)" strokeWidth="1"/>
            <path d="M16 7v18M10 12h12M10 25l6-4 6 4" stroke="#b8963e" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
            <circle cx="16" cy="9" r="2" fill="#b8963e"/>
          </svg>
        </div>

        <div style={s.title}>Reset Password</div>
        <div style={s.sub}>Choose a new password for your account.</div>

        {done ? (
          <div style={{textAlign:'center'}}>
            <div style={{fontSize:13,color:'#4caf82',marginBottom:20}}>Password updated successfully!</div>
            <button onClick={() => navigate('/login')} style={s.btn}>Go to login</button>
          </div>
        ) : (
          <>
            <style>{`
              .rp-field input { width:100%; background:rgba(255,255,255,0.06); border:0.5px solid rgba(255,255,255,0.15); border-radius:10px; padding:12px 16px; color:#f0ede8; font-size:13px; font-family:'DM Sans',sans-serif; outline:none; transition:all .2s; box-sizing:border-box; }
              .rp-field input:focus { background:rgba(255,255,255,0.1); border-color:rgba(184,150,62,0.6); box-shadow:0 0 0 3px rgba(184,150,62,0.1); }
              .rp-field label { display:block; font-size:10px; font-weight:500; color:rgba(200,190,170,0.7); letter-spacing:.1em; text-transform:uppercase; margin-bottom:6px; }
              .rp-btn:hover { background:rgba(212,176,106,1) !important; transform:translateY(-1px); }
            `}</style>

            <div style={{display:'flex',flexDirection:'column',gap:12,marginTop:24}}>
              <div className="rp-field">
                <label>New Password</label>
                <input type="password" placeholder="Min. 6 characters" value={password} onChange={e=>setPassword(e.target.value)} />
              </div>
              <div className="rp-field">
                <label>Confirm Password</label>
                <input type="password" placeholder="Repeat password" value={confirm} onChange={e=>setConfirm(e.target.value)} />
              </div>

              {error && <div style={{fontSize:11,color:'#f09595',background:'rgba(192,67,74,.15)',border:'0.5px solid rgba(192,67,74,.3)',borderRadius:8,padding:'8px 12px'}}>{error}</div>}

              <button onClick={handleSubmit} disabled={loading} className="rp-btn" style={s.btn}>
                {loading ? 'Updating...' : 'Set new password'}
              </button>
            </div>
          </>
        )}
      </div>
    </div>
  )
}

const s = {
  page: {
    minHeight:'100vh', background:'#04080f',
    display:'flex', alignItems:'center', justifyContent:'center',
    padding:24,
  },
  card: {
    width:'100%', maxWidth:380,
    background:'rgba(8,18,35,0.85)',
    backdropFilter:'blur(20px)',
    border:'0.5px solid rgba(184,150,62,0.2)',
    borderRadius:20,
    padding:'32px 28px',
    boxShadow:'0 24px 80px rgba(0,0,0,0.6)',
  },
  anchorWrap: {
    display:'flex', alignItems:'center', justifyContent:'center',
    marginBottom:20,
  },
  title: {
    fontFamily:'Cormorant Garamond, serif',
    fontSize:32, fontWeight:500,
    color:'#f0ede8',
    textAlign:'center', letterSpacing:'.02em',
    marginBottom:8,
  },
  sub: {
    fontFamily:'DM Sans, sans-serif',
    fontSize:12, color:'rgba(180,170,150,0.6)',
    textAlign:'center', letterSpacing:'.05em',
  },
  btn: {
    width:'100%', padding:'13px',
    borderRadius:10, border:'none',
    background:'rgba(184,150,62,1)',
    color:'#0a1628',
    fontFamily:'DM Sans, sans-serif',
    fontSize:13, fontWeight:500,
    cursor:'pointer', marginTop:4,
    transition:'all .2s',
  },
}
